import Ficha from './views/FichaView.vue'
import FichaList from './views/FichaListView.vue'
import SearchCriteriosView from './views/SearchCriteriosView'

export default [
  {
    path: '/ficha/:id',
    name: 'ficha',
    component: Ficha
  },
  {
    path: '/ficha/:idClub/:idSubarea',
    name: 'fichaClub',
    component: Ficha
  },
  {
    path: '/fichas',
    name: 'fichas',
    component: FichaList
  },
  {
    path: '/search/:searchCriterionProp',
    name: 'searchCriteriosView',
    props: true,
    component: SearchCriteriosView
  }
]
